import type { ContractTypeApi } from "./contractType";
import { isEmploymentContract } from "./contractType";

export type PayoutRateUi = "100" | "150" | "200";

export const PAYOUT_RATE_UI = {
  R100: "100",
  R150: "150",
  R200: "200",
} as const;

const PAYOUT_RATE_OPTIONS_FULL: readonly PayoutRateUi[] = [
  PAYOUT_RATE_UI.R100,
  PAYOUT_RATE_UI.R150,
  PAYOUT_RATE_UI.R200,
];
const PAYOUT_RATE_OPTIONS_EMPLOYMENT_OVERTIME: readonly PayoutRateUi[] = [
  PAYOUT_RATE_UI.R150,
  PAYOUT_RATE_UI.R200,
];

export function getAdminCommissionPayoutRateOptions(
  contractType: ContractTypeApi | null | undefined
): readonly string[] {
  return isEmploymentContract(contractType)
    ? PAYOUT_RATE_OPTIONS_EMPLOYMENT_OVERTIME
    : PAYOUT_RATE_OPTIONS_FULL;
}

export function tryParsePayoutRate(
  rawRate: string | number | null | undefined
): PayoutRateUi | null {
  const normalized = String(rawRate ?? "").trim().toLowerCase();
  if (!normalized) return null;

  if (normalized === "paid100" || normalized === "100") return PAYOUT_RATE_UI.R100;
  if (normalized === "paid150" || normalized === "150") return PAYOUT_RATE_UI.R150;
  if (normalized === "paid200" || normalized === "200") return PAYOUT_RATE_UI.R200;

  if (normalized.includes("100")) return PAYOUT_RATE_UI.R100;
  if (normalized.includes("150")) return PAYOUT_RATE_UI.R150;
  if (normalized.includes("200")) return PAYOUT_RATE_UI.R200;

  const asNumber = Number(rawRate);
  if (asNumber === 100) return PAYOUT_RATE_UI.R100;
  if (asNumber === 150) return PAYOUT_RATE_UI.R150;
  if (asNumber === 200) return PAYOUT_RATE_UI.R200;

  return null;
}

export function normalizePayoutRate(
  rawRate: string | number | null | undefined
): PayoutRateUi {
  return tryParsePayoutRate(rawRate) ?? PAYOUT_RATE_UI.R100;
}
